import { QueryClient } from 'react-query';
import queryKeys from '../constants/queryKeys';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  }
});
export const setQueryTicketData = (ticketId, updaterFn) => {
  queryClient.setQueryData([queryKeys.GET_TICKET, ticketId], updaterFn);
};

export const getQueryTicketData = ticketId =>
  queryClient.getQueryData([queryKeys.GET_TICKET, ticketId]);

export const invalidateTicketData = ticketId =>
  queryClient.invalidateQueries([queryKeys.GET_TICKET, ticketId]);
